import React, { useEffect, useState } from 'react'
import endpoint from "../../../auth/endpoint";
import { Link, Navigate } from "react-router-dom";
import Loader from "react-loader-advanced";
import './printCauseList.css' 

const CounselListArchive = () => {

    const [isLoading, setLoading] = useState(false);
    const [dailyCauseList, setDailyCauseList] = useState([]);
    const [date, setDate] = useState('');

    const dateSuffix = (day) => {
        if ((day == 1) || (day == 21) || (day == 31)) {
            return day + '' + "st";
        } else if ((day == 2) || (day == 22)) {
            return day + '' + "nd";
        } else if ((day == 3) || (day == 23)) {
            return day + '' + "rd";
        } else {
            return day + '' + "th";
        }
    }

    const formattedDate = date && (new Date(date).toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(new Date(date).toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        new Date(date).toLocaleDateString('en-us', { month: "long" }) + ", " + new Date(date).toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const curDate = new Date()
    const dateStr = (curDate.toLocaleDateString('en-us', { weekday: "long" }) + ", " + dateSuffix(curDate.toLocaleDateString('en-us', { day: "numeric" })) + " day of " +
        curDate.toLocaleDateString('en-us', { month: "long" }) + ", " + curDate.toLocaleDateString('en-us', { year: "numeric" })).toUpperCase();

    const alphabetArray = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    const todaysDate = () => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const day = String(currentDate.getDate()).padStart(2, '0');

        const formatDate = `${year}-${month}-${day}`;

        console.log("new", formatDate);
        return formatDate
    }

    useEffect(() => {
        // getDailyCauseList()
    }, [])

    // const getDailyCauseList = async () => {
    //     setLoading(true)
    //     await endpoint.get(`/case-diary/new-day-list/${todaysDate()}`)
    //         .then(({ data }) => {
    //             console.log("response", data.data)
    //             let causeArr = data.data

    //             const groupedByLocation = causeArr.reduce((result, obj) => {
    //                 const location = obj.location || 'N/A'; // fallback if location is missing

    //                 if (!result[location]) {
    //                     result[location] = {};
    //                 }

    //                 const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat + ' ' + (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : '');

    //                 if (!result[location][key]) {
    //                     result[location][key] = [];
    //                 }

    //                 result[location][key].push(obj);

    //                 return result;
    //             }, []);
    //             console.log("groupedByLocation", groupedByLocation)
    //             return
    //             setDailyCauseList(groupedByLocation)
    //             setLoading(false)
    //         }).catch((err) => {
    //             console.log(err)
    //             setLoading(false)
    //         })
    // }

    const handleFetchData = async () => {
        setLoading(true)
        await endpoint.get(`/case-diary/new-day-history-list/${date}`)
            .then(({ data }) => {
                console.log("response with supplied data", data.data)
                let causeArr = data.data

                const groupedByLocation = causeArr.reduce((result, obj) => {
                    const location = obj.location || 'N/A'; // fallback if location is missing

                    if (!result[location]) {
                        result[location] = {};
                    }

                    const key = obj.CaseType.case_type + ' ' + obj.CaseTypeCategory.case_type_cat + ' ' + (obj.AdjournmentType.id == 2 ? obj.AdjournmentType.id : '');

                    if (!result[location][key]) {
                        result[location][key] = [];
                    }

                    result[location][key].push(obj);

                    return result;
                }, []);
                console.log("groupedByLocation", groupedByLocation)
                setDailyCauseList(groupedByLocation)

                setLoading(false)
            }).catch((err) => {
                console.log(err)
                setLoading(false)
            })
    }

    //function that adds "judgement" to heading
    const splitHeading = (str) => {
        const firstSpaceIndex = str.indexOf(' ')
        const firstPart = str.slice(0, firstSpaceIndex)
        return (firstPart + ' ' + 'Judgment').toUpperCase()
    }

    //function that removes the adjournment id from heading
    const removeNumber = (str) => {
        const result = str.replace(/[0-9]/g, '')
        return (result + ' ' + '(s)').toUpperCase()
    }

    return (
        <>
            {isLoading && <div className="d-flex align-items-center justify-content-center vh-100">
                      <img
                        src={"/loading.gif"}
                        alt={""}
                        className="img-fluid"
                        style={{ maxWidth: "50px" }}
                      />
                    </div>}
            {!isLoading && <div id='divToPrint'>

                <div className='row mt-4'>
                    <div className='col-md-12 text-center' id='hideDate' style={{ textDecoration: `underline` }}> <h3>COUNSEL LIST ARCHIVE</h3><br />
                        </div>
                    <div className='col'>
                        <label className='text-danger' id='hideDate'><i>**Please select date and click on search to print counsel list**</i></label>
                        <div className="input-group mb-3" id='hideDate'>
                            <input type="date" className="form-control" aria-label="Recipient's username" aria-describedby="button-addon2"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                            />
                            <div className="input-group-append">
                                <button className="btn btn-outline-primary" type="button" onClick={handleFetchData} id="button-addon2">Search</button>
                            </div>
                        </div>

                    </div>
                    <div className='col'>

                    </div>
                </div>

                {isLoading && <Loader />}

                {!isLoading &&
                    <div className='row mt-4'>
                        <div className='col-md-12'>

                            {Object.entries(dailyCauseList).map(([location, groupings], locationIndex) => (
                                <div key={locationIndex}>
                                    {/* Location Header */}
                                    <div className='text-center mb-4' style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
                                        IN THE SUPREME COURT OF NIGERIA<br /> HOLDEN AT ABUJA <br /> CAUSE LIST FOR {date ? formattedDate : dateStr.toUpperCase()} <br />
                                        {location.toUpperCase()}
                                    </div>

                                    {Object.entries(groupings).sort(([keyA], [keyB]) => {
                                        const isMotionA = keyA.toLowerCase().includes("motion");
                                        const isMotionB = keyB.toLowerCase().includes("motion");

                                        if (isMotionA && !isMotionB) return -1; // Motion first
                                        if (!isMotionA && isMotionB) return 1;  // Appeal after Motion

                                        return keyA.localeCompare(keyB); // alphabetical fallback
                                    }).map(([headings, items], index) => (
                                        <div className='causeListHeading' key={index}>
                                            <div className='text-center mb-2' style={{
                                                color: `${headings.toUpperCase().includes("CIVIL") ? 'green' : headings.toUpperCase().includes("CRIMINAL") ? "red" : headings.toUpperCase().includes("POLITICAL") ? "blue" : ""}`
                                            }}>
                                                {headings.includes(2) ? `${alphabetArray[index]}. ${splitHeading(headings)}` : `${alphabetArray[index]}. ${removeNumber(headings)}`}
                                            </div>

                                            <div className='table-reponsive'>
                                                <table className="table mb-5" style={{ width: `100%` }}>
                                                    <thead className="thead-light">
                                                        <tr style={{ border: `1px solid black` }}>
                                                            <th style={{ maxWidth: `5px`, border: `1px solid black` }}>SN.</th>
                                                            <th scope="col" style={{ border: `1px solid black` }}>APPEAL NO.</th>
                                                            {headings.toUpperCase().includes("APPEAL") ?
                                                                <>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPELLANTS</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>RESPONDENTS</th>
                                                                </>
                                                                : <>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>PARTIES</th>
                                                                    <th scope="col" style={{ border: `1px solid black` }}>APPLICATIONS</th>
                                                                </>
                                                            }

                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            items.map((item, index) => (
                                                                <>
                                                                    {item.CaseAttachements && item.CaseAttachements.map((Case, index2) => (
                                                                        <tr key={`${index}-${index2}`} style={{ border: `1px solid black` }}>
                                                                            {(index2 === 0) && <td rowSpan={item.CaseAttachements.length} style={{ border: `1px solid black` }}>{index + 1}.</td>}
                                                                            <td style={{ border: `1px solid black`, color: `${item.CaseType.case_color}` }}><strong>{Case.suite_no}</strong></td>
                                                                            {headings.toUpperCase().includes("APPEAL") ?
                                                                                <>
                                                                                    <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                        <tr>{Case.appellants} {Case.otherAppellantCount === 1 ? (
                                                                                            <><strong> & Anor </strong></>
                                                                                        ) : Case.otherAppellantCount > 1 ? (
                                                                                            <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}</tr>
                                                                                        {/* <tr>{Case.appellants_title}</tr> */}
                                                                                    </td>
                                                                                    <td style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                        <tr>{Case.respondent}
                                                                                            {Case.otherRespondentCount === 1 ? (
                                                                                                <><strong> & Anor </strong></>
                                                                                            ) : Case.otherRespondentCount > 1 ? (
                                                                                                <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}</tr>
                                                                                        {/* <tr>{Case.respondent_title}</tr> */}
                                                                                    </td>
                                                                                </>
                                                                                :
                                                                                <>
                                                                                    {/* <td style={{ whiteSpace: `normal` }}>{Case.parties}</td> */}
                                                                                    <td className='text-center' style={{ whiteSpace: `normal`, border: `1px solid black` }}>
                                                                                        <tr>{Case.appellants}{Case.otherAppellantCount === 1 ? (
                                                                                            <><strong> & Anor </strong></>
                                                                                        ) : Case.otherAppellantCount > 1 ? (
                                                                                            <> & <strong>{Case.otherAppellantCount} Ors</strong></>
                                                                                        ) : (
                                                                                            ""
                                                                                        )}</tr>
                                                                                        {/* <tr>({Case.appellants_title})</tr> */}
                                                                                        <tr><div className='mt-2 mb-2'>VS.</div></tr>
                                                                                        <tr>{Case.respondent}{Case.otherRespondentCount === 1 ? (
                                                                                                <><strong> & Anor </strong></>
                                                                                            ) : Case.otherRespondentCount > 1 ? (
                                                                                                <> & <strong>{Case.otherRespondentCount} Ors</strong></>
                                                                                            ) : (
                                                                                                ""
                                                                                            )}</tr>
                                                                                        {/* <tr>({Case.respondent_title})</tr> */}
                                                                                    </td>
                                                                                    <td style={{ whiteSpace: `pre-wrap`, border: `1px solid black`, wordWrap: `break-word` }}>{Case.case_desc}</td>

                                                                                </>
                                                                            }
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                            ))
                                                        }
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}


                        </div>
                    </div>
                }

                {Object.entries(dailyCauseList).length > 0 &&
                    <div className='col-md-12 hideBtn'>
                        <button className="btn btn-outline-primary" type="button" onClick={() => window.print()} id="button-addon2">Print</button>
                    </div>
                }

            </div>}
        </>

    )
}

export default CounselListArchive